import { ThemeEvents } from '@theme/events';
import { formatMoney } from '@theme/money-formatting';

class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    this.limit = parseInt(this.dataset.limit) || 0;
    this.total = parseInt(this.dataset.total) || 0;
    this.format = this.dataset.format;
  }

  connectedCallback() {
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    document.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
  }

  handleCartUpdate(event) {
    if (event.detail && event.detail.resource && typeof event.detail.resource.total_price !== 'undefined') {
      this.total = event.detail.resource.total_price;
      this.updateUI();
    }
  }

  updateUI() {
    const left = Math.max(0, this.limit - this.total);
    const percentage = Math.min(100, (this.total / this.limit) * 100) || 0;
    const isUnlocked = this.total >= this.limit;

    this.setAttribute('data-unlocked', isUnlocked.toString());

    const progress = this.querySelector('.fs-bar__progress');
    if (progress) {
      progress.style.width = `${percentage}%`;
    }

    const percentText = this.querySelector('[data-percent-text]');
    if (percentText) {
      percentText.textContent = Math.round(percentage);
    }

    const amountLefts = this.querySelectorAll('[data-amount-left]');
    amountLefts.forEach(el => {
      el.innerHTML = formatMoney(left, this.format);
    });
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
